export class LoanGroup {


    constructor(private _commissionRateLimit: number, private _createdBy: string, private _createdOn: Date, private _id: number, private _initialCommissionRateLimit: number,
        private _updateRemark: string, private _overrideCommissionRateLimit?: number, private _formJId?: number) { }


    get FormJId(): number {
        return this._formJId;
    }
    set FormJId(value: number) {
        this._formJId = value;
    }
    get OverrideCommissionRateLimit(): number {
        return this._overrideCommissionRateLimit;
    }
    set OverrideCommissionRateLimit(value: number) {
        this._overrideCommissionRateLimit = value;
    }
    get UpdateRemark(): string {
        return this._updateRemark;
    }
    set UpdateRemark(value: string) {
        this._updateRemark = value;
    }
    get InitialCommissionRateLimit(): number {
        return this._initialCommissionRateLimit;
    }
    set InitialCommissionRateLimit(value: number) {
        this._initialCommissionRateLimit = value;
    }
    get Id(): number {
        return this._id;
    }
    set Id(value: number) {
        this._id = value;
    }
    get CreatedOn(): Date {
        return this._createdOn;
    }
    set CreatedOn(value: Date) {
        this._createdOn = value;
    }
    get CreatedBy(): string {
        return this._createdBy;
    }
    set CreatedBy(value: string) {
        this._createdBy = value;
    }
    get CommissionRateLimit(): number {
        return this._commissionRateLimit;
    }
    set CommissionRateLimit(value: number) {
        this._commissionRateLimit = value;
    }
}


export interface IAPILoanGroup {
    overrideCommissionRateLimit: number,
    updateRemark: string
}